/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {PermissionFormComponent as ɵc} from './permission-form/permission-form.component';
export {PermissionComponent as ɵb} from './permission.component';
export {declaration as ɵa} from './permission.module';
export {PermissionRoutes as ɵd} from './permission.routing';